import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const PageTitle = () => {
	const { t } = useTranslation();
	const [weather, setWeather] = useState(null);
	const [currentTime, setCurrentTime] = useState(new Date());

  const locale = document.cookie
    .split('; ')
    .find((row) => row.startsWith('locale='))
    ?.split('=')[1] || 'en';

useEffect(() => {
  const fetchWeather = async () => {
    try {
      const res = await fetch(
        "https://api.open-meteo.com/v1/forecast?latitude=40.4168&longitude=-3.7038&current_weather=true"
      );
      const data = await res.json();
      setWeather(data.current_weather);
    } catch (err) {
      console.error("Failed to fetch weather:", err);
    }
  };

  fetchWeather();
  const weatherInterval = setInterval(fetchWeather, 10 * 60 * 1000);

  const timeInterval = setInterval(() => {
    setCurrentTime(new Date());
  }, 1000);

  return () => {
    clearInterval(weatherInterval);
    clearInterval(timeInterval);
  };
}, []);


  const getWeatherDescription = (code, locale = 'en') => {
    const descriptions = {
      en: {
		  0: "the sky is clear",
		  1: "the sky is mostly clear",
		  2: "the sky is partly cloudy",
		  3: "the sky is overcast",
		  45: "the sky is foggy",
		  48: "the sky is foggy with frost",
		  51: "light drizzle is falling",
		  53: "moderate drizzle is falling",
		  55: "heavy drizzle is falling",
		  61: "light rain is falling",
		  63: "moderate rain is falling",
		  65: "heavy rain is falling",
		  71: "light snow is falling",
		  73: "moderate snow is falling",
		  75: "heavy snow is falling",
		  77: "snow grains are falling",
		  80: "light rain showers are expected",
		  81: "moderate rain showers are expected",
		  82: "violent rain showers are occurring",
		  95: "a thunderstorm is ongoing",
		  96: "a thunderstorm with hail is ongoing",
		  99: "a severe thunderstorm with hail is ongoing"
		},
        it: {
		  0: "il cielo è sereno",
		  1: "il cielo è per lo più sereno",
		  2: "il cielo è parzialmente nuvoloso",
		  3: "il cielo è coperto",
		  45: "il cielo è nebbioso",
		  48: "il cielo è nebbioso con brina",
		  51: "pioviggina leggermente",
		  53: "pioviggina moderatamente",
		  55: "pioviggina intensamente",
		  61: "ci sono piogge leggere",
		  63: "ci sono piogge moderate",
		  65: "ci sono piogge intense",
		  71: "sta nevicando leggermente",
		  73: "sta nevicando moderatamente",
		  75: "sta nevicando copiosamente",
		  77: "ci sono fiocchi di neve",
		  80: "ci sono rovesci leggeri",
		  81: "ci sono rovesci moderati",
		  82: "ci sono rovesci violenti",
		  95: "ci sono temporali",
		  96: "ci sono temporali con grandine",
		  99: "ci sono forti temporali con grandine"
		},
		es: {
		  0: "el cielo está despejado",
		  1: "el cielo está mayormente despejado",
		  2: "el cielo está parcialmente nublado",
		  3: "el cielo está cubierto",
		  45: "el cielo está cubierto por niebla",
		  48: "el cielo está con niebla y escarcha",
		  51: "hay llovizna ligera",
		  53: "hay llovizna moderada",
		  55: "hay llovizna intensa",
		  61: "llueve ligeramente",
		  63: "llueve moderadamente",
		  65: "llueve intensamente",
		  71: "nieva ligeramente",
		  73: "nieva moderadamente",
		  75: "nieva intensamente",
		  77: "hay copos de nieve",
		  80: "hay chubascos ligeros",
		  81: "hay chubascos moderados",
		  82: "hay chubascos violentos",
		  95: "hay tormenta",
		  96: "hay tormenta con granizo",
		  99: "hay una tormenta severa con granizo"
		}


    };

    return descriptions[locale]?.[code] || descriptions[locale]?.[0] || 'tempo sconosciuto';
  };

  const renderWeatherLine = () => {
    if (!weather) return null;

    const temp = Math.round(weather.temperature);
    const description = getWeatherDescription(weather.weathercode, locale);

    const now = new Date();
    const options = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: locale === 'en',
      timeZone: 'Europe/Madrid',
    };
    const timeInMadrid = now.toLocaleTimeString(locale, options);

    if (locale === 'it') {
      return `Tanto per sapere: a Madrid sono le ${timeInMadrid}, ${description} e ci sono ${temp}°C.`;
    }

    if (locale === 'es') {
      return `Solo para que lo sepas: en Madrid son las ${timeInMadrid}, ${description} y hay ${temp}°C.`;
    }

    return `Just to know: in Madrid it's ${timeInMadrid}, ${description} and it's ${temp}°C.`;
  };

  return (
    <div className="container mt-5 mt-xl-10">
      <div className="row mb-5 g-3 g-xl-5 align-items-end">
        <div className="col-lg-12">
          <h1>
            <span className="display-4" style={{ lineHeight: '90%' }}>
              {t("home.line1", "Hi! I'm Alberto")}<br />
            </span>
            <span className="display-1 text-black" style={{ fontWeight: 'bold', lineHeight: '90%' }}>
              {t("home.title1", "Digital Dedicated")}<br />
              {t("home.title2", "Human Inspired")}
            </span>
          </h1>

          <h4 className="text-black display-4" style={{ lineHeight: '90%' }}>
            {t("home.line2", "ITALIAN BASED IN MADRID.")}<br />
            {t("home.line3", "IF I SEE SOMETHING, I CAN PHOTOGRAPH IT, COOK IT, OR VISIT IT. AND ONE DOES NOT EXCLUDE THE OTHER.")}<br />
            <span style={{ fontSize: "50%", lineHeight: "90%", display: "block", marginTop: "1rem" }}>
              {renderWeatherLine()}
            </span>
          </h4>
        </div>
      </div>
    </div>
  );
};

export default PageTitle;
